import React from "react";
import LogoTersuave from "../../../assets/img/interactua/logo_company.png";
import LogoColorin from "../../../assets/img/comunidad/logo_header.png";
import LogoProveedores from "../../../assets/img/proveedores/logo_disal.png";
import "../../../assets/scss/components/app-loader.scss";
import "../../../assets/scss/Custom/Loading.scss";
import { variants } from "../../../constants/variants";
class SpinnerComponent extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100 d-flex justify-content-center">
        <div className="d-flex justify-content-center flex-column">
          <img
            className="logoEmpresa"
            src={
              window.config.VARIANT === variants.TERSUAVE
                ? LogoTersuave
                : window.config.VARIANT === variants.COLORIN
                ? LogoColorin
                : LogoProveedores
            }
            height="70px"
            alt="logo"
          />

          <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p
            style={{
              alignSelf: "center",
              background: "transparent",
              color: "white",
              padding: "10px 15px",
            }}
          >
            Estamos cargando la información...
          </p>
        </div>
      </div>
    );
  }
}

export default SpinnerComponent;
